
import React, { useEffect } from "react";
// import { useRouter } from "next/router";
import help from "../../assets/images/help-center2.png";
import store, { RootState, useAppDispatch } from "../../store";
import { useSelector } from "react-redux";
import { fetchTutorials } from "../../store/reducers/tutorials";
import Video from "../../interfaces/Video";
import UnderLineTitle from "../shared/UnderlineTitle";
import { useNavigate } from "react-router-dom";

interface VideoTileProps {
  video: Video;
}

const VideoTile: React.FC<VideoTileProps> = ({ video }) => {
  const router = useNavigate();

  return (
    <div className="bg-white shadow-md rounded-xl overflow-hidden h-[280px] w-full flex flex-col justify-between">
      <div className="bg-[#A894EA] h-1/2 flex items-center justify-center">
        <img
          src={video.thumbnail}
          alt="Video Thumbnail"
          className="max-h-[100px] object-contain"
        // style={{ objectFit: "cover", width: "100%", maxHeight: "140px" }}
        // width={500}
        // height={500}
        />
      </div>
      <div className="p-4 h-1/2 flex flex-col justify-between">
        <p className="text-app-blue text-sm font-semibold">{video.title}</p>
        <p className="text-sm text-app-blue mb-1">
          Duration: <span className="font-normal">{video.duration}</span>
        </p>
        <button
          className="bg-app-yellow text-[#1B1C57] font-semibold rounded-full py-1 px-6 hover:opacity-90 w-fit"
          onClick={() => router("/help/viliyo-tutorials?video=" + video.id)}
        >
          View
        </button>
      </div>
    </div>
  );
};

interface VideoListProps {
  videos: Video[];
}

const VideoList: React.FC<VideoListProps> = ({ videos }) => {
  return (
    <div className="w-full px-4 py-6">
      <div className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-3 largescreen:grid-cols-4 gap-6">
        {videos.map((video) => (
          <div key={video.id} className="w-full max-w-[430px] h-full">
            <VideoTile video={video} />
          </div>))}
      </div>
    </div>
  );
};

const Section = ({ videos, title }: { videos: Video[]; title: string }) => {
  return (
    <div>
      <UnderLineTitle title={title} />
      <VideoList videos={videos} />
    </div>
  );
};

const Tutorials = () => {
  const dispatch = useAppDispatch();
  const { isLoading, error, videos } = useSelector((state: RootState) => state.tutorials);


  useEffect(() => {
    store.dispatch(fetchTutorials());
  }, [dispatch]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="w-full">
      <div className="w-full">
        <div className="flex p-4 justify-between items-center rounded-xl bg-app-blue text-white">
          <div>
            <span className="font-bold text-xl text-app-yellow text-left">
              Fastest way to master Viliiyo!
            </span>
            <p className="w-3/4 text-white font-light text-sm text-left whitespace-normal break-words">
              Viliyo tutorials help you master the art of setting up and
              conducting highly engaging virtual training sessions and more.
            </p>
          </div>
          <img alt="Help Image" src={help} width={75} height={50} />
        </div>
      </div>
      <div className="pt-4">

        {/* Recently Added video grid */}
        <Section title="Recently Added" videos={videos} />
        {/* All Tutorials video grid */}
        <Section title="All Tutorials" videos={videos} />
      </div>
    </div>
  );
};

export default Tutorials;
